/**
 * Interpolate a template string with variables.
 */
export const interpolate = (template: string, variables: Record<string, string | number>) => {
  if (!template) return;
  return template.replace(/{(.*?)}/g, (_, key) => variables[key.trim()]?.toString() ?? '');
};
